import { targetBlank } from '../../../style/webStyles.js'
import { TextLinkStyle } from '../TextLink/TextLinkStyle.js'

export const A = ({ href, underline = true, color, children }) => (
  <TextLinkStyle href={href} hrefAttrs={targetBlank} underline={underline} color={color}>
    {children}
  </TextLinkStyle>
)
